import React from 'react';
import {Switch, Route, Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import LoginPage from './pages/login';
import HomePage from './pages/home/index';
import UsersPage from './pages/home/users';
import ReportsPage from './pages/home/reports/index';
import ReportsUsersPage from './pages/home/reports/users';
import ReportsDevicesPage from './pages/home/reports/devices';
import ReportsAcademicsPage from './pages/home/reports/academics';
import AuditPage from './pages/home/audit/index';
import ProfilePage from './pages/home/profile';
import SettingsPage from './pages/home/settings';

const App = (props) => {
  const PrivateRoute = ({component: Component, ...rest}) => (
    <Route
      {...rest}
      render={localProps => (
        props.loggedIn === true ? <Component {...localProps} /> : <Redirect to='/login'/>
      )}
    />
  );

  const GuestRoute = ({component: Component, ...rest}) => (
    <Route
      {...rest}
      render={localProps => (
        props.loggedIn === false ? <Component {...localProps} /> : <Redirect to='/'/>
      )}
    />
  );

  return (
    <main>
      <Switch>
        <GuestRoute exact path="/login" component={LoginPage}/>
        <PrivateRoute exact path="/" component={HomePage}/>
        <PrivateRoute exact path="/users" component={UsersPage}/>
        <PrivateRoute exact path="/reports" component={ReportsPage}/>
        <PrivateRoute exact path="/reports/users" component={ReportsUsersPage}/>
        <PrivateRoute exact path="/reports/devices" component={ReportsDevicesPage}/>
        <PrivateRoute exact path="/reports/academics" component={ReportsAcademicsPage}/>
        <PrivateRoute exact path="/audit" component={AuditPage}/>
        <PrivateRoute exact path="/settings" component={SettingsPage}/>
        <PrivateRoute exact patch="/profile" component={ProfilePage}/>
      </Switch>
    </main>
  );
};

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js